<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to cut off list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="viewedByOwner" dark icon title="View in My Attendance" @click="viewInMyAttendance">
                        <v-icon>access_time</v-icon>
                    </v-btn>
                    <v-chip v-if="frozenPeriod" label small class="warning" dark title="This period is already Frozen. You will not be able to change this record.">Frozen</v-chip>
                    <v-chip v-if="closedPeriod" label small class="grey darken-2" dark title="This period is already Closed. You will not be able to change this record.">Closed</v-chip>

                    <v-menu v-if="showMenu" left v-model="menu_status" offset-y :disabled="isMenuDisabled">
                        <template v-slot:activator="{ on }">
                            <v-btn :color="commonfn.getStatusButtonColor(overtime_details.status)" dark v-on="on" :loading="loading_status" class="mr-0">
                                <span class="ml-7">{{ commonfn.getStatusDescription(overtime_details.status) }}</span>
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-for="(item, index) in menuItems" :key="index" @click="item.action">
                                <v-list-tile-title small>{{ item.label }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>

                    <!-- fallback (no actions available) -->
                    <v-btn v-else-if="!loading" :color="commonfn.getStatusButtonColor(overtime_details.status)" dark class="mr-0">
                        {{ commonfn.getStatusDescription(overtime_details.status) }}
                    </v-btn>
                
                </v-toolbar>
            </v-card>

            <v-alert v-if="!loading && approved_Timesheet" :value="true" color="warning" icon="warning" outline class="mt-8">
                The timesheet for this period is already <b>Approved</b>. You will not be able to change this record.
            </v-alert>
            
            <!-- OVERTIME DETAILS -->
            <v-card v-if="!loading && overtime_details" class="elevation-1 mt-5 mb-5">
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold primary--text">OVERTIME DETAILS</span>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" :pageId="helpPageId" color="black"></help-link>
                </v-toolbar>
                <v-layout row wrap> 
                    <v-flex xs12 sm6 class="mt-10">
                        <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Requested By :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                <v-chip small @click="viewUserProfile(overtime_details, $store.state.userId)" class="user-chip-container">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(overtime_details.userId)"></v-img>
                                    </v-avatar>
                                    {{overtime_details.firstName}} {{overtime_details.lastName}}
                                </v-chip>
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Date :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{overtime_details.transDate|moment('dddd, DD MMM YYYY')}}
                            </v-flex>  
                        </v-layout> 
                        <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Duration :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{overtime_details.startTime|moment('hh:mm a')}} - {{overtime_details.endTime|moment('hh:mm a')}}
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Break Time :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{overtime_details.breakTime}} minutes
                            </v-flex>  
                        </v-layout>         
                    </v-flex>
                    <v-flex xs12 sm6 class="mb-10">
                        <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row mt-5'"> 
                            <v-flex xs4 class="text-xs-left">
                                Total Hours :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{overtime_details.hoursStr}}
                            </v-flex>    
                        </v-layout>      
                        <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Chargeable Hours :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{overtime_details.chargeableHours}}
                            </v-flex>  
                        </v-layout>  
                        <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Charging Type : 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                <span v-if="overtime_details.offsetOrPay==1">Time Off in Lieu (TOIL)</span>
                                <span v-else>Payroll (Paid Overtime)</span>
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Rate : 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{ overtimeRateDescription }}
                            </v-flex>  
                        </v-layout>
                        <v-layout v-if="overtime_details.remarks" row wrap :class="isMobile? 'content-row-mobile' : 'content-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Remarks : 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{overtime_details.remarks}}
                            </v-flex>  
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>

            <!-- ATTACHMENTS -->
            <v-card v-if="!loading" class="elevation-1 mt-5 mb-5"> 
                <v-toolbar flat height="35px">
                    <span class="font-weight-bold primary--text">ATTACHMENTS</span>
                    <v-spacer></v-spacer>
                    <v-btn v-if="enableForEditRights" icon title="Add Attachments" @click="showUpload">
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="attachments"
                    :hide-actions="attachments.length<6"
                    :loading="loading_attachment"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr>
                            <td @click="previewAttachment(props.item)" title="Click to preview file">
                                <div class="clickable wrapped-filename">
                                    {{ props.item.fileName }}
                                </div>
                            </td>
                            <td>{{ props.item.createdOn | moment('MMM DD, YYYY') }}</td>
                            <td>
                                <v-btn v-if="enableForEditRights" icon title="Delete Attachment" @click="showDeleteAttachment(props.item)" :disabled="loading_attachment">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </td> 
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>


            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <!-- updates history component -->
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="selectedOvertimeId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogOvertime" width="600" persistent>   
            <overtime ref="overtimeRef" :showTransDatePicker="false" @send="getOvertime(false)" :dialogOvertime.sync="dialogOvertime"></overtime>
        </v-dialog>
        <v-dialog v-model="dialogPreview" fullscreen hide-overlay transition="dialog-bottom-transition">
            <preview ref="refPdfPreviewComponet" :dialogPreview.sync="dialogPreview"></preview>
        </v-dialog>
        <v-dialog v-model="dialogDelete" width="500">
            <delete ref="refDeleteComponent" :dialogDelete.sync="dialogDelete" @okDelete="deleteHandler"></delete>
        </v-dialog>
        <v-dialog v-model="dialogUpload" fullscreen hide-overlay transition="dialog-bottom-transition"> 
            <upload ref="uploadRef" :dialogUpload.sync="dialogUpload" @send="getOvertime(false)"></upload>
        </v-dialog>
        <v-dialog v-model="dialogTeamSelector" width="700">
            <team-selector :teams="matchingTeams" :dialogTeamSelector.sync="dialogTeamSelector"></team-selector>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="selectedOvertimeId" @refresh="updateHandler"></status-messaging>
    </v-layout>  
</template>

<script>

import { syncTeamContext } from '@/helpers/team-selector'
import overtimeApi from '@/api/overtime'
import commonfn from '@/common/functions'   //for refactor
import AppPageID from '@/constants/app_page_ids'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import awsS3Helper from '@/helpers/aws-s3'
import OvertimeRateType from '@/constants/overtime-rate-types'
import AWSS3DocumentType from '@/constants/aws-s3-document-types'
import { hasDeleteRights, hasEditRights } from '@/helpers/access-permissions'
import { hasTeamEditRights, hasTeamDeleteRights, hasTeamApproverRights, hasTeamSelfApproverRights } from '@/helpers/myteams-permissions'

export default {     
    name: 'OvertimeDetails',
    metaInfo: {
        title: 'Overtime Details',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Overtime Details' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'overtime': () => import('@/components/Overtime/AddEditOvertime'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory'),
        'delete': () => import('@/components/BasicPopups/Delete'),
        'upload': () => import('@/components/Overtime/AddAttachments'),
        'preview': () => import('@/components/FilePreview/Preview'),
        'team-selector': () => import('@/components/Team/TeamSelector')
    },   
    data () {
        return {
            commonfn,
            awsS3Helper,
            headers: [
                {text: 'File',align: 'left',value: 'name', width: '70%', sortable:false},
                {text: 'Created On',align: 'left',value: 'status',  width: '25%', sortable:false},
                {text: 'Delete',align: 'left',value: '',  width: '5%', sortable:false}
            ],
            dialogPreview: false,
            error: false,
            errorMessage: '',
            loading: false,
            loading_delete: false,
            loading_status: false,
            loading_attachment: false,
            menu_status: false,
            message: null,
            dialogDelete: false,
            cutoff_details: null,
            overtime_details: null,
            dialogOvertime:false,
            dialogUpload: false,
            attachments: [],
            deleteOvertimeAttachmentId: null,
            deleteFunction: null,
            dialogTeamSelector: false,
            matchingTeams: []
        }
    },
    methods: {  
        showUpload(){
            this.dialogUpload = true
            this.$refs.uploadRef.setData(this.selectedOvertimeId)
        },
        deleteHandler() {
            if (typeof this.deleteFunction === 'function') {
                this.deleteFunction()
                this.dialogDelete = false
            }
        },
        showDeleteOvertime() {
            this.$refs.refDeleteComponent.setMessage("Delete this Overtime record?")
            this.deleteFunction = () => this.deleteOvertime()
            this.dialogDelete = true
        },
        showDeleteAttachment(data) {
            this.deleteOvertimeAttachmentId = data.overtimeAttachmentId
            this.$refs.refDeleteComponent.setMessage("Delete this attachment?")
            this.deleteFunction = () => this.deleteAttachment()
            this.dialogDelete = true
        },
        async deleteAttachment() {
            try {
                this.loading_attachment = true
                const response = await overtimeApi.deleteAttachment(this.deleteOvertimeAttachmentId)
                if (response && response.status == 200) {
                    await this.getOvertime(false)
                    this.loading_attachment = false
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async approve() {
            try {
                this.loading_status = true
                var data = {
                    overtimeId: this.overtime_details.overtimeId
                }
                const response = await overtimeApi.approve(data, this.userPageKey)
                if (response && response.status == 200) {
                    await this.getOvertime(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async setForReview() {
            try {
                this.loading_status = true
                var data = {
                    overtimeId: this.overtime_details.overtimeId
                }
                const response = await overtimeApi.forReview(data)
                if (response && response.status == 200) {
                    await this.getOvertime(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async reject() {
            try {
                this.loading_status = true
                var data = {
                    overtimeId: this.overtime_details.overtimeId
                }
                const response = await overtimeApi.reject(data, this.userPageKey)
                if (response && response.status == 200) {
                    await this.getOvertime(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        viewUserProfile(data, loggedInUserId) {
            if (data.userId == loggedInUserId)
                this.$router.push(`/myprofile`)
            else 
                this.$router.push(`/hr/employees/${data.userId}`)
        },
        showEditOvertime() {
            var data = {
                mode: 'Edit',
                transDate: this.overtime_details.transDate,
                overtimeId: this.overtime_details.overtimeId,
                projectId: this.overtime_details.projectId,
                projectTaskId: this.overtime_details.projectTaskId,
                breakTime: this.overtime_details.breakTime,
                hours: this.overtime_details.hours,
                startTime: this.overtime_details.startTime,
                endTime: this.overtime_details.endTime,
                status: this.overtime_details.status,
                offsetOrPay: this.overtime_details.offsetOrPay,
                // premiumOnly: this.overtime_details.premiumOnly,
                rateType: this.overtime_details.rateType,
                updatedBy: this.overtime_details.updatedBy,
                updatedByName: this.overtime_details.updatedByName,
                updatedByRemarks: this.overtime_details.updatedByRemarks,
                remarks: this.overtime_details.remarks
            }
            this.$refs.overtimeRef.setParams(data)
            this.dialogOvertime = true
        },
        async deleteOvertime() {
            try {
                this.loading_status = true
                var data = {
                    overtimeId: this.overtime_details.overtimeId
                }
                const response = await overtimeApi.delete(data)
                if (response && response.status == 200) {
                    this.loading_status = false
                    this.dialogDelete = false
                    this.$router.go(-1)
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        viewInMyAttendance() {
            this.$router.push(`/myattendance/daily/${this.$moment(this.overtime_details.transDate).format('YYYY-MM-DD')}`)
        },
        getWorkshiftType(strict) {
            if (strict) return '(Strict Shift)'
            return '(Flexible Shift)'
        },
        async previewAttachment(item) {
            try {
                this.loading_attachment = true 
                const response = await overtimeApi.getAttachmentUrl(this.overtime_details.userId, item.fileName)
                if (response && response.status == 200) {
                    var file = {
                        name: response.data.fileName,
                        type: 'Pdf',
                        url: response.data.url,
                        downloadUrl: awsS3Helper.getEmployeeDocumentUrl(this.overtime_details.userId, response.data.fileName, AWSS3DocumentType.OvertimeAttachment)
                    }
                    this.$refs.refPdfPreviewComponet.setParams(file)
                    this.loading_attachment = false
                    this.dialogPreview = true
                }
            }catch(error){
                console.log(error)
                this.error = true
                this.errorMessage = error
            }
        },
        async getOvertime(show_loading) {
            try {
                if (show_loading) this.loading = true
                const response = await overtimeApi.getById(this.selectedOvertimeId, this.userPageKey)
                if (response && response.status == 200) {
                    this.cutoff_details = response.data.cutoffItem
                    this.overtime_details = response.data.overtimeItem
                    this.attachments = response.data.overtimeItem.attachments
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getOvertime(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Overtime Details'
        })

        await this.getOvertime(true)

        const result = await syncTeamContext(this.overtime_details.userId)
        if (result && result.action === 'SHOW_DIALOG') {
            this.matchingTeams = result.teams
            this.dialogTeamSelector = true
        }
    },
    computed: {
        hasDeleteRights() {
            return hasDeleteRights(this.$router.currentRoute.path)
        },
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path) ||
                hasTeamEditRights(AppPageID.TeamOvertime)
        },
        hasTeamApproverRights() {
            return hasTeamApproverRights(AppPageID.TeamOvertime)            
        },
        hasTeamSelfApproverRights() {
            return hasTeamSelfApproverRights(AppPageID.TeamOvertime)
        },
        hasTeamDeleteRights() {
            return hasTeamDeleteRights(AppPageID.TeamOvertime)
        },
        hasEditAndApprover() {
            return this.hasEditRights && this.hasTeamApproverRights
        },
        menuItems() {
            if (!this.overtime_details) return []

            const items = []

            const canEdit =
                this.hasEditRights &&
                (this.created_status || this.rejected_status || this.processed_status)

            const canDelete =
                (this.hasDeleteRights || this.hasTeamDeleteRights) &&
                (this.created_status || this.rejected_status)

            const canForReview =
                this.hasEditRights &&
                this.created_status

            const canApprove = this.viewedByOwner ?
                this.hasTeamSelfApproverRights && (this.forReview_status || this.rejected_status) :
                this.hasTeamApproverRights && (this.forReview_status || this.rejected_status)

            const canReject = this.viewedByOwner ?
                this.hasTeamSelfApproverRights && (this.forReview_status || this.approved_status || this.processed_status) :
                this.hasTeamApproverRights && (this.forReview_status || this.approved_status || this.processed_status)

            // Order matters (same as your UI)
            if (canEdit) {
                items.push({ label: 'Edit', action: this.showEditOvertime })
            }

            if (canForReview) {
                items.push({ label: 'For Review', action: this.setForReview })
            }

            if (canDelete) {
                items.push({ label: 'Delete', action: this.showDeleteOvertime })
            }

            if (canReject) {
                items.push({ label: 'Reject', action: this.reject })
            }

            if (canApprove) {
                items.push({ label: 'Approve', action: this.approve })
            }

            return items
        },
        isMenuDisabled() {
            return this.frozenPeriod || this.closedPeriod || this.approved_Timesheet
        },
        showMenu() {
            return !this.loading && this.menuItems.length > 0
        },
        selectedOvertimeId() {
            return this.$route.params.overtimeId
        },
        viewedByOwner() {
            if (this.overtime_details)
                return this.$store.state.userId == this.overtime_details.userId
        },
        userPageKey() {
            if (this.$router.currentRoute.path.includes('company/overtime')) {
                return pageKeys.overtime_company_approver
            }else if (this.$router.currentRoute.path.includes('myteam/overtime')) {
                return pageKeys.overtime_team_approver
            }else{
                return pageKeys.overtime
            }
        },
        pageLink() {
            if (this.overtime_details) {
                if (this.viewedByOwner) {
                    if (this.$router.currentRoute.path.includes('company/overtime')) {
                        return `company${this.$router.currentRoute.path.replace('/myattendance','')}`
                    }else{
                        return `myteam${this.$router.currentRoute.path.replace('/myattendance','')}`
                    }
                }else{
                    return `myattendance${this.$router.currentRoute.path.replace('/myteam','').replace('/company','')}`
                }
            }
        },
        commentsData() {
            if (this.overtime_details) {
                return {
                    pageQueryId: this.selectedOvertimeId,
                    pageItemCreatedBy: this.overtime_details.userId,
                    pageLink: this.pageLink,
                    pageKey: pageKeys.overtime_team_approver,
                    notificationTypeId: notificationTypes.overtime
                }
            }
        },
        frozenPeriod(){
            if (this.cutoff_details) {
                return this.cutoff_details.status==commonfn.getStatusCode('Frozen')
            }
        },
        closedPeriod(){
            if (this.cutoff_details) {
                return this.cutoff_details.status==commonfn.getStatusCode('Closed')
            }
        },
        deleted_status() {
            if (this.overtime_details) {
                return this.overtime_details.status==commonfn.getStatusCode('Deleted')
            }
        },
        created_status() {
            if (this.overtime_details) {
                return this.overtime_details.status==commonfn.getStatusCode('Created')
            }
        },
        forReview_status() {
            if (this.overtime_details) {
                return this.overtime_details.status==commonfn.getStatusCode('For Review')
            }
        },
        approved_status() {
            if (this.overtime_details) {
                return this.overtime_details.status==commonfn.getStatusCode('Approved')
            }
        },
        processed_status() {
            if (this.overtime_details) {
                return this.overtime_details.status==commonfn.getStatusCode('Processed')
            }
        },
        rejected_status() {
            if (this.overtime_details) {
                return this.overtime_details.status==commonfn.getStatusCode('Rejected')
            }
        },
        approved_Timesheet() {
            if (this.cutoff_details) {
                return this.cutoff_details.timeReportStatus==commonfn.getStatusCode('Approved')
            } 
        },
        helpPageId() {
            if (this.viewedByOwner) {
                return 'overtime-page'
            }else{
                if (this.$router.currentRoute.path.includes('company')) {
                    return 'overtime-review-company'
                }else{
                    return 'overtime-review-team'
                }
            }
        },
        overtimeRateDescription() {
            if (this.overtime_details) {
                return OvertimeRateType.find(x => x.rateType == this.overtime_details.rateType).description
            }
        },
        enableForEditRights() {
            return this.hasEditRights &&
                    !this.frozenPeriod &&
                    !this.closedPeriod &&
                    (this.created_status||this.rejected_status)
        }
    }
}
</script>
<style scoped>
.content-row-mobile {
    padding:0px 20px 0px 20px;
}
.content-row {
    padding:0px 20px 0px 50px;
}
</style>